import {
  AppBar,
  Box,
  Button,
  Grid,
  Paper,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import routes from '../../../../Utils/routes.json';
import { TabPanel } from '@material-ui/lab';
import { useEffect, useState } from 'react';
import KenCard from '../../../../global_components/KenCard';
import KenSelectWrap from '../../../../global_components/KenSelect';
import RoomAvailablity from './RoomAvailablity';
import SeatingArrangement from './SeatingArrangement';
import {
  getSeatingArrangement,
  getFacilityData,
  postFacilityData,
  getFacilityBookingDetails,
  postSeatingArrangement,
  getStudentExamRoom,
} from '../../../../Utils/apiServices';
import moment from 'moment';
import KenDialogBox from '../../../../global_components/KenDialogBox';
import KenLoader from '../../../../Components/KenLoader/index';

const selectOptionsSpace = [
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
];

const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'SEATING PLAN',
    url: routes.seatingPlan,
  },
  {
    head: 'GENERATE SEATING PLAN',
    url: routes.seatingPlanArrangement,
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    color: '#FFFFFF',
    background: '#EB5757',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  normal: {
    color: '#FFFFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  publishGenerate: {
    color: '#FFFFFF',
    background: '#979797',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  publishView: {
    color: '#FFFFFF',
    background: '#F2994A',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Blue: {
    color: '#FFFF',
    background: '#03248F',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Green: {
    color: '#FFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '102px',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

function TabPanels(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: '10px' }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const SeatingPlanArrangement = (props) => {
  const location = useLocation();
  const classes = useStyles();
  const SEATING_COLUMNS = 6;
  const [layoutSize, setLayoutSize] = useState(true);
  const [currentSeatingPlanData, setCurrentSeatingPlanData] = useState(
    location?.state?.data
  );
  const [roomChoosen, setRoomChoosen] = useState([]);
  const [studentDataList, setStudentDataList] = useState([]);
  let id = currentSeatingPlanData?.eligibleStudents;
  let examId = currentSeatingPlanData?.id;
  const [roomsBooked, setRoomsBooked] = useState([]);
  const [facilityData, setFacilityData] = useState();
  const [deletedRooms, setDeletedRooms] = useState([]);
  const [swapSeats, setSwapSeats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [status, setStatus] = useState(false);
  const [statusSwaping, setStatusSwaping] = useState(false);
  const [selectValueSpace, setSelectValueSpace] = useState(
    selectOptionsSpace[0].value
  );
  console.log('selectValueSpace', selectValueSpace);
  // Tab Panel states
  const [value, setValue] = useState(0);

  useEffect(() => {
    setLoading(true);
    getSeatingArrangement(examId)
      .then((res) => {
        setLoading(false);
        if (res !== null) {
          setStudentDataList(res);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log('Seating Plan Arrangement', err);
      });
    getFacilityBookingDetails(examId)
      .then((res) => {
        setLoading(false);
        console.log('getFacilityBookingDetails', res);
        if (res !== null) {
          setSelectValueSpace(res?.candSpacing);
        }
        const Rooms_Booked =
          res === null
            ? []
            : res?.bfw?.map((item, index) => {
                return {
                  // id: String(index + 1),
                  id: item?.facilityId,
                  room: item?.name,
                  capacity: item?.capacity,
                };
              });
        const prevRooms =
          res == null
            ? []
            : res.bfw?.map((item, index) => {
                return item?.name;
              });
        setRoomChoosen(Rooms_Booked);
        setRoomsBooked(prevRooms);
      })
      .catch((err) => {
        setLoading(false);
        console.log('Seating Plan Arrangement', err);
      });
    getFacilityData()
      .then((res) => {
        setLoading(false);
        const RoomsInfo =
          res === null
            ? []
            : res.map((item, index) => {
                return {
                  // id: String(index + 1),
                  id: item?.id,
                  room: item?.roomName,
                  capacity: item?.capacity,
                };
              });
        setFacilityData(RoomsInfo);
      })
      .catch((err) => {
        setLoading(false);
        console.log('Seating Plan Arrangement', err);
      });
  }, [status, value,statusSwaping]);

  const handleRoomDeletion = (rooms) => {
    console.log('[handleRoomDeletion] rooms: ', rooms);
    // setDeletedRooms([...deletedRooms, room]);
    setDeletedRooms((prev) => [...prev, ...rooms]);
    console.log('[handleRoomDeletion] deletedRooms: ', deletedRooms);
  };

  const handleRoomAddition = (rooms) => {
    console.log('[handleRoomAddition] room: ', rooms);
    // setDeletedRooms([...deletedRooms, room]);
    const updatedRooms = deletedRooms.filter(
      (delRoom) => delRoom.room !== rooms.room
    );
    setDeletedRooms(updatedRooms);
    console.log('handleRoomAddition', deletedRooms);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  let roomDropdown = [];
  const [selectValueCourse, setSelectValueCourse] = useState(
    roomDropdown.length > 0 ? roomDropdown[0].value : ''
  );
  if (roomChoosen.length > 0) {
    // setSelectValueCourse(roomDropdown[0].value)
    const rooms = roomChoosen.map((ele) => {
      roomDropdown.push({
        label: `Room ${ele.room}`,
        value: ele.id,
      });
    });
    // setSelectValueCourse(roomDropdown[0].value)
    // roomDropdown.push(rooms);
  }

  const handleSelectChangeCourse = (e) => {
    setSelectValueCourse(e.target.value);
  };

  // Eligible for seating arrangement
  const [eligible, setEligible] = useState(false);
  const [numStudents, setNumStudents] = useState(0);
  // selectOptionsCourse.push()
  let seatWidth = '100%';
  // dialog box
  const [dialogState, setDialogState] = useState(false);

  const handleDialog = () => {
    setDialogState((prevState) => !prevState);
  };

  const handleSaveSeatingPlan = (data, students, rooms, seatsChange) => {
    setLoading(true);
    console.log('seat swaped', seatsChange);
    if (seatsChange && seatsChange.length > 0) {
      postSeatingArrangement(seatsChange)
        .then((res) => {
          setLoading(false);
          if (res.success === 'true' || true) {
            handleDialog();
            setMessage('Seat change done successfully');
            console.log('res message seatsChange', res.message);
            setSwapSeats();
            setStatusSwaping(true);
            setStatus(true);
          }
        })
        .catch((err) => {
          setLoading(false);
          setStatus(false);
          console.log('Failed to add. Please try again.', err);
        });
    } else {
      let notAvailableRooms = [
        ...new Set(deletedRooms?.map((item) => item.room)),
      ];
      let notSelectedRooms = notAvailableRooms.toString();
      let availableRooms = [...new Set(rooms.map((item) => item.room))];
      roomsBooked.forEach((item, index) => {
        availableRooms.push(item);
      });
      const newRooms = [...new Set(availableRooms)];
      let uniqueRooms = newRooms.filter((val) => !roomsBooked.includes(val));
      let selectedRooms = uniqueRooms.toString();
      if (data.eligibleStudents <= 0) {
        setLoading(false);
        setMessage(
          currentSeatingPlanData?.eligibleStudents <= 0 &&
            `Number of eligible students are ${currentSeatingPlanData.eligibleStudents}`
        );
        handleDialog();
      } else if (students < data.eligibleStudents) {
        setLoading(false);
        setMessage(
          numStudents < currentSeatingPlanData?.eligibleStudents &&
            `Number of selected student's(${numStudents}) are less than eligible students (${currentSeatingPlanData.eligibleStudents}) `
        );
        handleDialog();
      } else {
        // handleDialog();
        const payload = {
          examId: data?.id,
          selectedRooms: selectedRooms,
          examDuration: data?.duration,
          candidateSpacing: selectValueSpace,
          deleteRoom: false,
          deleteFacilityRoom: '',
        };
        if (notSelectedRooms.length > 0) {
          payload.deleteRoom = true;
          payload.deleteFacilityRoom = notSelectedRooms;
        }
        if (notSelectedRooms.length > 0 || selectedRooms.length > 0) {
          postFacilityData(payload)
            .then((res) => {
              setLoading(false);
              setStatus(true);
              if (res.success === 'true' || true) {
                getStudentExamRoom(examId)
                  .then((res) => {
                    setLoading(false);
                    if (res !== null) {
                      setStudentDataList(res);
                      // console.log('getStudentExamRoom', res);
                    }
                  })
                  .catch((err) => {
                    setLoading(false);
                    console.log('Student Exam Room', err);
                  });

                console.log('res message', res.message);
              }
            })
            .catch((err) => {
              setLoading(false);
              setStatus(false);
              console.log('Failed to add. Please try again.', err);
            });
        } else {
          setLoading(false);
        }
      }
    }
  };
  return (
    <Box>
      {loading && <KenLoader />}
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Seating Plan
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            <KenDialogBox
              /*  title={
                <Typography
                  variant="h6"
                  className={classes.dialogHeader}
                  align="center"
                >
                  Sorry!
                </Typography>
              } */
              open={dialogState}
              fullWidth={true}
              maxWidth={'xs'}
              handleClose={() => handleDialog()}
              negativeButtonClick={() => handleDialog()}
              positiveButtonClick={() => handleDialog()}
              positiveButtonText="Edit Again"
              negativeButtonText="Close"
              // dividers
            >
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box
                    style={{
                      display: 'flex',
                      alignContent: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Typography align="center">
                      {message && message !== null && message}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>{' '}
            </KenDialogBox>
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={() => {
                handleSaveSeatingPlan(
                  currentSeatingPlanData,
                  numStudents,
                  roomChoosen,
                  swapSeats
                );
              }}
            >
              Save
            </Button>
          </Grid>
        </Toolbar>
      </AppBar>
      <AppBar
        position="static"
        elevation={0}
        className={classes.header}
        style={{ margin: '20px 0' }}
      >
        <Toolbar style={{ color: '#505F79', fontWeight: 'bold' }}>
          <Typography variant="p" style={{ marginRight: '25px' }}>
            {currentSeatingPlanData?.course}
          </Typography>
          <Typography variant="p">
            {moment(currentSeatingPlanData?.date).format('dddd, MMMM Do YYYY')}
          </Typography>
        </Toolbar>
      </AppBar>

      <div className="cardlsitbox">
        <KenCard elevation={0} style={{ padding: 0 }}>
          <Box>
            <Box
              sx={{ borderBottom: 1, borderColor: 'divider' }}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0 25px',
              }}
            >
              <Tabs
                style={{
                  padding: '0 14px',
                }}
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label="Room Availablity"
                  {...a11yProps(0)}
                  style={{ fontSize: '12px' }}
                />
                {eligible && roomsBooked.length > 0 && (
                  <Tab
                    label="SEATING Arrangement"
                    {...a11yProps(1)}
                    style={{ fontSize: '12px' }}
                  />
                )}
              </Tabs>
            </Box>
            <TabPanels value={value} index={0}>
              <RoomAvailablity
                currentSeatingPlanData={currentSeatingPlanData}
                SEATING_COLUMNS={SEATING_COLUMNS}
                setEligible={setEligible}
                roomChoosen={roomChoosen}
                setRoomChoosen={setRoomChoosen}
                numStudents={numStudents}
                setNumStudents={setNumStudents}
                selectValueSpace={selectValueSpace}
                setSelectValueSpace={setSelectValueSpace}
                selectOptionsSpace={selectOptionsSpace}
                facilityData={facilityData}
                handleRoomDeletion={handleRoomDeletion}
                handleRoomAddition={handleRoomAddition}
              />
            </TabPanels>

            <TabPanels value={value} index={1}>
              {roomChoosen && roomChoosen.length > 0 ? (
                <SeatingArrangement
                  studentsData={studentDataList}
                  roomDropdown={roomDropdown}
                  layoutSize={layoutSize}
                  setLayoutSize={setLayoutSize}
                  selectValueCourse={selectValueCourse}
                  setSelectValueCourse={setSelectValueCourse}
                  handleSelectChangeCourse={handleSelectChangeCourse}
                  SEATING_COLUMNS={SEATING_COLUMNS}
                  roomChoosen={roomChoosen}
                  numStudents={numStudents}
                  selectValueSpace={selectValueSpace}
                  facilityData={facilityData}
                  setSwapSeats={setSwapSeats}
                  examId={examId}
                  handleDialog={handleDialog}
                  setMessage={setMessage}
                  setValue={setValue}
                />
              ) : (
                <Paper>
                  <Typography align="center">
                    Rooms are Not selected!!
                  </Typography>
                </Paper>
              )}
            </TabPanels>
          </Box>
        </KenCard>
      </div>
    </Box>
  );
};

export default SeatingPlanArrangement;
